module.exports = __webpack_public_path__ + "img/SER-A-2-I.3ed6ebf5.png";